import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 单个商品的信息
 * @typedef GoodsItem
 * @property {number} id 商品唯一id
 * @property {string} name 商品名称
 * @property {number} savePerMonth 每月节省的金额
 * @property {number} price 价格
 * @property {number} applePrice 苹果上的价格?
 */

/**
 * 商品信息
 * @typedef GoodsInfo
 * @property {string} title 标题
 * @property {goodsId} goodsId 商品id
 * @property {Array<>} sets 商品列表
 */

/**
 * 获取商品信息
 * @param goodsId 商品id
 * @param setId 子商品id
 * @return {Promise<GoodsInfo>}
 */
export async function getGoods(goodsId, setId) {
  return axios
    .get(`${Urls.DOMAIN_YKT}/Shop/Data/Goods`, {
      params: {
        goodsId,
        setId
      }
    })
    .then(data => {
      let detail = null
      if (data.result.code === 0) {
        detail = data.detail
      }
      return detail
    })
}

/**
 * @typedef OrderInfo 订单信息
 * @property {string} [transactionCode] 账单流水号，支付成功后由支付系统生成
 * @property {string} orderId 订单号
 * @property {string} [productName] 商品名称
 * @property {Date} createTime 订单创建时间
 * @property {number} orderStatus 订单状态
 * @property {number} userId 用户Id
 * @property {number} amount 订单金额
 */

/**
 * 创建订单
 * @param {number} productId 商品id
 * @param {number} quantity 购买数量，默认1
 */
export async function createOrder(productId, source, quantity = 1) {
  console.log('source:', source)
  return axios
    .get(`${Urls.DOMAIN_YKT}/Order/Order/CreateOrder`, {
      params: {
        productId,
        source,
        quantity
      }
    })
    .then(data => {
      return data
    })
}

/**
 * 查询订单详情
 * @param {string} orderId 订单id
 * @return {Promise<*>}
 */
export async function getOrder(orderId) {
  return axios
    .get(`${Urls.DOMAIN_YKT}/Order/Order/GetOrder`, {
      params: {
        orderId
      }
    })
    .then(data => {
      let detail = null
      if (data.result.code === 0) {
        detail = data.detail
      }
      return detail
    })
}

/**
 * 创建支付订单
 * @param {string} payMethod 支付方式
 * @param {int} tradeType 交易类型 App=1,JSAPI支付(公众号)=2，Native支付(扫码)=3，H5支付=4，小程序支付=5
 * @param {string} orderId 订单号
 * @param {int} appId 支付应用Id
 * @param {string} {code} 短信验证码，紧财币支付需要
 */
export async function createPayOrder(
  payMethod,
  tradeType,
  orderId,
  appId,
  code
) {
  return axios.get(`${Urls.DOMAIN_YKT}/Order/Order/PayOrder`, {
    params: {
      payMethod,
      tradeType,
      orderId,
      appId,
      code
    }
  })
}

/**
 * 支付状态
 * @type {{paymentSuccess: number, paying: number, paymentFailed: number, unPaid: number}}
 */
export const PaymentStatus = {
  /**
   * 未支付
   */
  unPaid: 1,
  /**
   * 支付中
   */
  paying: 2,
  /**
   * 支付成功
   */
  paymentSuccess: 3,
  /**
   * 支付失败
   */
  paymentFailed: 4,
  /**
   *已关闭
   */
  isClosed: 5,
  /**
   * 取消
   */
  cancel: 6,
  /**
   * 已退款
   */
  isRefund: 7
}

/**
 * 查询订单支付状态
 * @param {string} orderId 订单id
 * @return {Promise<number>} 支付状态
 */
export async function queryOrderStatus(orderId) {
  return axios
    .get(`${Urls.DOMAIN_YKT}/Order/Order/QueryOrderStatus`, {
      params: {
        orderId
      }
    })
    .then(data => {
      let paymentStatus = PaymentStatus.paymentFailed
      if (data.result.code === 0) {
        paymentStatus = data.detail
      }

      return paymentStatus
    })
    .catch(() => {
      return PaymentStatus.paymentFailed
    })
}

/**
 * 获取订单列表
 * @return {Promise<Array>} 获取订单列表
 */
export function queryOrderDetails(query, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Order/Order/QueryOrderDetails`,
    method: 'post',
    headers: {
      'Ykt-ViewState': viewState
    },
    data: query
  })
    .then(data => {
      return data.result.code === 0 ? data : null
    })
    .catch(() => null)
}

/**
 * 发送财币支付短信验证码
 */
export function sendVCurrencyPaySms(orderId) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Order/Validate/SendVCurrencyPaySms`,
    method: 'post',
    data: {
      orderId
    }
  })
}
